import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import { UserType } from 'utils/ACLHelper';
import Roles from 'utils/enums/Roles';

import { CoursesList } from './Courses/IOCoursesList';
import { EventsList } from './Events/IOEventsList';
import { ManageUsers } from './User/IOUsersList';

export const Io = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        path="users"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.INCOMINGS_ADMIN]
            }}
            user={currentUser}
          >
            <ManageUsers />
          </PrivateRoute>
        }
      />
      <Route
        path="courses"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.INCOMINGS_ADMIN],
              userType: UserType.INCOMING
            }}
            user={currentUser}
          >
            <CoursesList />
          </PrivateRoute>
        }
      />
      <Route
        path="events"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.INCOMINGS_ADMIN],
              userType: UserType.INCOMING
            }}
            user={currentUser}
          >
            <EventsList />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export { CoursesList, CoursesListFrame, IOCourse } from './Courses';
export { EventsList, EventsListFrame, IOEvent } from './Events';
